module.exports = __webpack_public_path__ + "media/images/zagreb-bg-826e485425256d43f9be6152e213b3a8.svg";